module.exports = __webpack_public_path__ + "static/media/close.9892dfca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/documentUpload/close.svg
// module id = 135
// module chunks = 0